// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Define styles for navigation links */
.nav-link {
  background-color: #1b2e35; /* Sky blue background color */
  color: white; /* White text color */
  font-weight: bold; /* Bold text */
  padding: 0.5rem 1rem; /* Padding */
  border-radius: 0.25rem; /* Rounded corners */
  text-decoration: none; /* Remove underline */
}

/* Hover effect */
.nav-link:hover {
  background-color: #6495ED; /* Darker shade of blue on hover */
}

/* Heading style */
.heading {
  font-family: 'Roboto', sans-serif; /* Apply Roboto font */
  font-weight: bold; /* Make the font bold */
  color: black; /* Set text color to black */
}

/* Description paragraph style */
.description {
  color: black; /* Set text color to black */
}

/* Table style */
.table-heading {
  background-color: #87CEEB; /* Sky blue background color */
  color: white; /* White text color */
  font-weight: bold; /* Bold text */
  padding: 0.5rem 1rem; /* Padding */
  border: 1px solid #ccc; /* Border */
}

/* Highlight on hover */
.table-heading:hover {
  background-color: #dcdcdc; /* Lighter shade of gray on hover */
}

.dflYoa {
  table-layout: auto !important;
}

.flex {
  display: flex;
}

.justify-center {
  justify-content: center;
}

.items-center {
  align-items: center;
}

.h-full {
  height: 100%;
}

.p-4 {
  padding: 1rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.space-x-4 > :not(:last-child) {
  margin-right: 1rem;
}

.bg-blue-500 {
  background-color: #3b82f6;
}

.text-white {
  color: #ffffff;
}

.bg-gray-300 {
  background-color: #d1d5db;
}

.text-gray-800 {
  color: #1f2937;
}

.mt-8 {
  margin-top: 2rem;
}

/* Background image style */
.home-container {
  flex-direction: column;
  justify-content: center; /* Center vertically */
  align-items: center; /* Center horizontally */
  text-align: center;
}

/* Adjust text positioning and color */
.home-text {
  color: black; /* Set text color to black */
  text-align: center;
  max-width: 80%; /* Optional: Limit width for better readability */
}
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

.navbar {
  width: 100%;
  background-color: #333;
  color: #fff;
  padding: 1rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.home-container {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: calc(100% - 60px); /* Adjust according to navbar height */
  margin-top: 60px; /* Adjust according to navbar height */
  color: #fff;
  text-align: center;
}

`, "",{"version":3,"sources":["webpack://./src/components/style.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,yBAAyB,EAAE,8BAA8B;EACzD,YAAY,EAAE,qBAAqB;EACnC,iBAAiB,EAAE,cAAc;EACjC,oBAAoB,EAAE,YAAY;EAClC,sBAAsB,EAAE,oBAAoB;EAC5C,qBAAqB,EAAE,qBAAqB;AAC9C;;AAEA,iBAAiB;AACjB;EACE,yBAAyB,EAAE,kCAAkC;AAC/D;;AAEA,kBAAkB;AAClB;EACE,iCAAiC,EAAE,sBAAsB;EACzD,iBAAiB,EAAE,uBAAuB;EAC1C,YAAY,EAAE,4BAA4B;AAC5C;;AAEA,gCAAgC;AAChC;EACE,YAAY,EAAE,4BAA4B;AAC5C;;AAEA,gBAAgB;AAChB;EACE,yBAAyB,EAAE,8BAA8B;EACzD,YAAY,EAAE,qBAAqB;EACnC,iBAAiB,EAAE,cAAc;EACjC,oBAAoB,EAAE,YAAY;EAClC,sBAAsB,EAAE,WAAW;AACrC;;AAEA,uBAAuB;AACvB;EACE,yBAAyB,EAAE,mCAAmC;AAChE;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,uBAAuB,EAAE,sBAAsB;EAC/C,mBAAmB,EAAE,wBAAwB;EAC7C,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,YAAY,EAAE,4BAA4B;EAC1C,kBAAkB;EAClB,cAAc,EAAE,iDAAiD;AACnE;AACA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B,EAAE,sCAAsC;EACrE,gBAAgB,EAAE,sCAAsC;EACxD,WAAW;EACX,kBAAkB;AACpB","sourcesContent":["/* Define styles for navigation links */\n.nav-link {\n  background-color: #1b2e35; /* Sky blue background color */\n  color: white; /* White text color */\n  font-weight: bold; /* Bold text */\n  padding: 0.5rem 1rem; /* Padding */\n  border-radius: 0.25rem; /* Rounded corners */\n  text-decoration: none; /* Remove underline */\n}\n\n/* Hover effect */\n.nav-link:hover {\n  background-color: #6495ED; /* Darker shade of blue on hover */\n}\n\n/* Heading style */\n.heading {\n  font-family: 'Roboto', sans-serif; /* Apply Roboto font */\n  font-weight: bold; /* Make the font bold */\n  color: black; /* Set text color to black */\n}\n\n/* Description paragraph style */\n.description {\n  color: black; /* Set text color to black */\n}\n\n/* Table style */\n.table-heading {\n  background-color: #87CEEB; /* Sky blue background color */\n  color: white; /* White text color */\n  font-weight: bold; /* Bold text */\n  padding: 0.5rem 1rem; /* Padding */\n  border: 1px solid #ccc; /* Border */\n}\n\n/* Highlight on hover */\n.table-heading:hover {\n  background-color: #dcdcdc; /* Lighter shade of gray on hover */\n}\n\n.dflYoa {\n  table-layout: auto !important;\n}\n\n.flex {\n  display: flex;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.p-4 {\n  padding: 1rem;\n}\n\n.mb-4 {\n  margin-bottom: 1rem;\n}\n\n.space-x-4 > :not(:last-child) {\n  margin-right: 1rem;\n}\n\n.bg-blue-500 {\n  background-color: #3b82f6;\n}\n\n.text-white {\n  color: #ffffff;\n}\n\n.bg-gray-300 {\n  background-color: #d1d5db;\n}\n\n.text-gray-800 {\n  color: #1f2937;\n}\n\n.mt-8 {\n  margin-top: 2rem;\n}\n\n/* Background image style */\n.home-container {\n  flex-direction: column;\n  justify-content: center; /* Center vertically */\n  align-items: center; /* Center horizontally */\n  text-align: center;\n}\n\n/* Adjust text positioning and color */\n.home-text {\n  color: black; /* Set text color to black */\n  text-align: center;\n  max-width: 80%; /* Optional: Limit width for better readability */\n}\nbody, html {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.navbar {\n  width: 100%;\n  background-color: #333;\n  color: #fff;\n  padding: 1rem;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n}\n\n.home-container {\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  min-height: calc(100% - 60px); /* Adjust according to navbar height */\n  margin-top: 60px; /* Adjust according to navbar height */\n  color: #fff;\n  text-align: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
